import { useEffect, useState } from "react";
import { AuduitItem } from "../../components/audits/AuduitItem";
import { ListPicker } from "../../components/generic/ListPicker";
import { useAuduitHook } from "../../hooks/useAuduitsHook";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import { usePickerhook } from "../../hooks/usePickerhook";

const AuditsActivity = () => {
  const companypicked = usePickerhook();
  const statuspicked = usePickerhook();
  const { UserOrgs } = useOrganizationHook();
  const { orgauduits } = useAuduitHook();
  const [renderedaudit, setrenderedaudit] = useState(orgauduits);

  const AuditsActivityItem = () => (
    <div className="border border-gray-400 p-3 "> </div>
  );
  useEffect(() => {
    setrenderedaudit(orgauduits);
  }, [orgauduits]);

  useEffect(() => {
     if (statuspicked?.pickedRole?.name.toLowerCase().includes("success")) {
      setrenderedaudit(
        orgauduits.filter((i: any) => i.status.toLowerCase().includes ("success"))
      );
    }
    if (statuspicked?.pickedRole?.name.toLowerCase() .includes ("failed")) {
      setrenderedaudit(
        orgauduits.filter((i: any) => i.status.toLowerCase(). includes ("failed"))
      );
    }
  }, [statuspicked?.pickedRole]);
  return (
    <div className="flex justify-between flex-col  items-start w-full p-4 ">
      <p className="text-sm font-semibold">
        Audit Log({`${orgauduits.length}`}){" "}
      </p>
      <div className="flex jus gap-4">
        <ListPicker
          hook={statuspicked}
          notitle
          title="Log status"
          list={[
            { name: "Failed", code: "failed" },
            { name: "Success", code: "success" },
          ]}
        />{" "}
        <ListPicker
          hook={companypicked}
          notitle
          title="Company"
          list={UserOrgs.map((i) => {
            return { name: i.orgName, code: i.id };
          })}
        />
      </div>

      {renderedaudit?.map((i: any) => (
        <AuduitItem item={i} />
      ))}
    </div>
  );
};
export { AuditsActivity };
